import { forwardRef } from 'react';
import type React from 'react';
import styled from 'styled-components';

type OwnProps = React.SVGProps<SVGSVGElement>;

const Clock = styled.svg.attrs({ className: 'h-24 stroke-grey-5 w-16' })``;

const ClockIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <Clock
    viewBox="0 0 16 24"
    fill="none"
    ref={ref}
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_226_18612)">
      <circle cx="8" cy="12" r="7" strokeWidth="2" />
      <path
        d="M8 9.0387V13.2454L10.1078 14.525"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_226_18612">
        <rect width="16" height="16" fill="white" transform="translate(0 4)" />
      </clipPath>
    </defs>
  </Clock>
));

export default ClockIcon;
